module.exports = __webpack_public_path__ + "static/media/face-female-4.9c1b5042.jpg";